import { createTheme } from '@mui/material/styles';
const {
  augmentColor
} = createTheme().palette;
const createColor = mainColor => augmentColor({
  color: {
    main: mainColor
  }
});
export default createColor;